export default __webpack_public_path__ + "static/media/tutorial-05.de48f52d.jpg";